module.exports = __webpack_public_path__ + "img/1@2x.6b40acc6.png";